import * as types from '../actions/types';

const initialState = {
  notax: 0,
  registered: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.DISABLEMENT:
      return {
        ...state,
        notax: action.payload
      };
    case types.STATE_REGISTARTION_2020:
      return {
        ...state,
        registered: action.payload
      };

    default:
      return state;
  }
};
